import { Injectable } from '@angular/core';

import { RidangoReduxAction, SetCustomerProfileInformation, SetProfileInformationDTO } from '@ridango/core';
import { CustomerRegistrationCompleteRequest } from '../customer.service';

import { Action } from 'redux';

export interface CustomerAction extends Action {
    type: string;
    payload?: any;
}

@Injectable()
export class CustomerActions {
    static GET_CUSTOMER_PROFILE = '[Customer]: Get customer profile';
    static GET_CUSTOMER_PROFILE_FAILED = '[Customer]: Get customer profile failed';
    static SET_CUSTOMER_PROFILE = '[Customer]: Set customer profile';
    static CLEAR_CUSTOMER_PROFILE = '[Customer]: Clear customer';

    static SET_CUSTOMER_PROFILE_ACTIONS = '[Customer Detail] Set customer profile actions';
    static SET_CUSTOMER_PROFILE_FIELDS = '[Customer Detail] Set customer profile fields';

    static SAVE_CUSTOMER_PROFILE = '[Customer Edit] Save customer profile';
    static SAVE_CUSTOMER_PROFILE_SUCCESS = '[Customer Edit] Save customer profile success';
    static SAVE_CUSTOMER_PROFILE_FAILED = '[Customer Edit] Save customer profile failed';
    static COMPLETE_CUSTOMER_REGISTRATION = '[Customer Edit] Complete customer registration';
    static COMPLETE_CUSTOMER_REGISTRATION_SUCCESS = '[Customer Edit] Complete customer registration success';
    static COMPLETE_CUSTOMER_REGISTRATION_FAILED = '[Customer Edit] Complete customer registration failed';

    static SEND_CUSTOMER_PROFILE_DELETION_EMAIL = '[Customer Delete] Send customer profile deletion email';
    static SEND_CUSTOMER_PROFILE_DELETION_EMAIL_SUCCESS =
        '[Customer Delete] Send customer profile deletion email success';
    static SEND_CUSTOMER_PROFILE_DELETION_EMAIL_FAILED =
        '[Customer Delete] Send customer profile deletion email failed';

    static DELETE_CUSTOMER_PROFILE = '[Customer Delete] Delete customer profile';
    static DELETE_CUSTOMER_PROFILE_SUCCESS = '[Customer Delete] Delete customer profile success';
    static DELETE_CUSTOMER_PROFILE_FAILED = '[Customer Delete] Delete customer profile failed';

    static SEND_CUSTOMER_NEW_EMAIL = '[Customer Edit] Send customer new email';
    static SEND_CUSTOMER_NEW_EMAIL_SUCCESS = '[Customer Edit] Send customer new email success';
    static SEND_CUSTOMER_NEW_EMAIL_FAILED = '[Customer Edit] Send customer new email failed';
    static RESET_CUSTOMER_NEW_EMAIL = '[Customer Edit] Reset customer new email';

    static SAVE_CUSTOMER_NEW_EMAIL = '[Customer Edit] Save customer new email';
    static SAVE_CUSTOMER_NEW_EMAIL_SUCCESS = '[Customer Edit] Save customer new email success';
    static SAVE_CUSTOMER_NEW_EMAIL_FAILED = '[Customer Edit] Save customer new email failed';

    static SEND_CUSTOMER_LANG = '[Customer Edit] Send customer new language';
    static SEND_CUSTOMER_LANG_SUCCESS = '[Customer Edit] Send customer new language success';
    static SEND_CUSTOMER_LANG_FAILED = '[Customer Edit] Send customer new language failed';

    getCustomerProfile(): CustomerAction {
        return {
            type: CustomerActions.GET_CUSTOMER_PROFILE
        };
    }

    getCustomerProfileFailed(error: any): RidangoReduxAction {
        return {
            type: CustomerActions.GET_CUSTOMER_PROFILE_FAILED,
            payload: error
        };
    }

    setCustomerProfile(payload): CustomerAction {
        return {
            type: CustomerActions.SET_CUSTOMER_PROFILE,
            payload: payload
        };
    }

    clearCustomerProfile(): CustomerAction {
        return {
            type: CustomerActions.CLEAR_CUSTOMER_PROFILE
        };
    }

    setProfileActions(profileActions: string[]): RidangoReduxAction {
        return {
            type: CustomerActions.SET_CUSTOMER_PROFILE_ACTIONS,
            payload: profileActions
        };
    }

    setProfileFields(profileFields: string[]): RidangoReduxAction {
        return {
            type: CustomerActions.SET_CUSTOMER_PROFILE_FIELDS,
            payload: profileFields
        };
    }

    saveCustomerProfile(payload: SetProfileInformationDTO | SetCustomerProfileInformation): RidangoReduxAction {
        return {
            type: CustomerActions.SAVE_CUSTOMER_PROFILE,
            payload: payload
        };
    }

    saveCustomerProfileSuccess(payload: boolean): RidangoReduxAction {
        return {
            type: CustomerActions.SAVE_CUSTOMER_PROFILE_SUCCESS,
            payload: payload
        };
    }

    saveCustomerProfileFailed(error: any): RidangoReduxAction {
        return {
            type: CustomerActions.SAVE_CUSTOMER_PROFILE_FAILED,
            payload: error
        };
    }

    completeCustomerRegistration(payload: CustomerRegistrationCompleteRequest): RidangoReduxAction {
        return {
            type: CustomerActions.COMPLETE_CUSTOMER_REGISTRATION,
            payload: payload
        };
    }

    completeCustomerRegistrationSuccess(payload: boolean): RidangoReduxAction {
        return {
            type: CustomerActions.COMPLETE_CUSTOMER_REGISTRATION_SUCCESS,
            payload: payload
        };
    }

    completeCustomerRegistrationFailed(error: any): RidangoReduxAction {
        return {
            type: CustomerActions.COMPLETE_CUSTOMER_REGISTRATION_FAILED,
            payload: error
        };
    }

    sendCustomerProfileDeletionEmail(): RidangoReduxAction {
        return {
            type: CustomerActions.SEND_CUSTOMER_PROFILE_DELETION_EMAIL
        };
    }

    sendCustomerProfileDeletionEmailSuccess(payload: any): RidangoReduxAction {
        return {
            type: CustomerActions.SEND_CUSTOMER_PROFILE_DELETION_EMAIL_SUCCESS,
            payload: payload
        };
    }

    sendCustomerProfileDeletionEmailFailed(error: any): RidangoReduxAction {
        return {
            type: CustomerActions.SEND_CUSTOMER_PROFILE_DELETION_EMAIL_FAILED,
            payload: error
        };
    }

    deleteCustomerProfile(token: string): RidangoReduxAction {
        return {
            type: CustomerActions.DELETE_CUSTOMER_PROFILE,
            payload: token
        };
    }

    deleteCustomerProfileSuccess(payload: any): RidangoReduxAction {
        return {
            type: CustomerActions.DELETE_CUSTOMER_PROFILE_SUCCESS,
            payload: payload
        };
    }

    deleteCustomerProfileFailed(error: any): RidangoReduxAction {
        return {
            type: CustomerActions.DELETE_CUSTOMER_PROFILE_FAILED,
            payload: error
        };
    }

    sendCustomerNewEmail(payload: string): RidangoReduxAction {
        return {
            type: CustomerActions.SEND_CUSTOMER_NEW_EMAIL,
            payload: payload
        };
    }

    sendCustomerNewEmailSuccess(payload: boolean): RidangoReduxAction {
        return {
            type: CustomerActions.SEND_CUSTOMER_NEW_EMAIL_SUCCESS,
            payload: payload
        };
    }

    sendCustomerNewEmailFailed(error: any): RidangoReduxAction {
        return {
            type: CustomerActions.SEND_CUSTOMER_NEW_EMAIL_FAILED,
            payload: error
        };
    }

    resetCustomerNewEmail(): RidangoReduxAction {
        return {
            type: CustomerActions.RESET_CUSTOMER_NEW_EMAIL
        };
    }

    saveCustomerNewEmail(payload: string): RidangoReduxAction {
        return {
            type: CustomerActions.SAVE_CUSTOMER_NEW_EMAIL,
            payload: payload
        };
    }

    saveCustomerNewEmailSuccess(payload: boolean): RidangoReduxAction {
        return {
            type: CustomerActions.SAVE_CUSTOMER_NEW_EMAIL_SUCCESS,
            payload: payload
        };
    }

    saveCustomerNewEmailFailed(error: any): RidangoReduxAction {
        return {
            type: CustomerActions.SAVE_CUSTOMER_NEW_EMAIL_FAILED,
            payload: error
        };
    }

    sendCustomerLang(payload: string): RidangoReduxAction {
        return {
            type: CustomerActions.SEND_CUSTOMER_LANG,
            payload: payload
        };
    }

    sendCustomerLangSuccess(payload: boolean): RidangoReduxAction {
        return {
            type: CustomerActions.SEND_CUSTOMER_LANG_SUCCESS,
            payload: payload
        };
    }

    sendCustomerLangFailed(error: any): RidangoReduxAction {
        return {
            type: CustomerActions.SEND_CUSTOMER_LANG_FAILED,
            payload: error
        };
    }
}
